import { NAME as namespace } from './constants';
import { advertisingImagesReducer as reducer } from './reducer';
export var advertisingImages = {
  namespace: namespace,
  reducer: reducer
};
export default advertisingImages;